import { SolarFunnelContext } from '~/machines/solar-funnel/types';
import { LDFlags, LDClient } from '~/providers/launch-darkly';
import { PerchEnergyContext } from './types';

export const requiresAffirmativeConsent = (context: SolarFunnelContext | PerchEnergyContext) => {
  const state =
    context.funnelPacket?.utility.state.abbreviation ||
    context.utilitySelection?.state.abbreviation;
  return state === 'NJ' && LDClient.variation(LDFlags.ffEnableNJAffirmativeConsent);
};

const shouldFallBackToAccountNumber = (context: PerchEnergyContext) =>
  LDClient.variation(LDFlags.accountNumberBackup) &&
  ['error', 'timed_out'].includes(context.utilityConnectStatus!);

export const isSignupAvailable = (context: PerchEnergyContext) => {
  const allowedStates = ['NY', 'NJ'];
  return allowedStates.includes(context.utilitySelection?.state.abbreviation || '');
};

const shouldAdvance = context => {
  const status = context.utilityConnectStatus; // Avoid repeated access and '!'

  const isVerified = status === 'verified';

  const isFailureStatus = ['timed_out', 'error', 'rejected'].includes(status);
  const isAccountNumberBackupEnabled = LDClient.variation(LDFlags.accountNumberBackup);
  const isBillImageUploadEnabled = LDClient.variation(LDFlags.billImageUpload);
  const areBackupFeaturesDisabled = !(isAccountNumberBackupEnabled || isBillImageUploadEnabled);

  const shouldAdvanceOnFailure = areBackupFeaturesDisabled && isFailureStatus;

  return isVerified || shouldAdvanceOnFailure;
};

export const perchMachineGuards = {
  isSignupAvailable,
  requiresAffirmativeConsent,
  shouldFallBackToAccountNumber,
  shouldAdvance,
};
